/* @ngInject */

export default (
  $q,
  $rootScope,
  $scope,
  $mdDateLocale,
  eventService,
  webpage,
  jobTypeService,
  jobTypesService,
  labelsService,
  actionService
) => {
  $scope.Model = {
    availableJobTypes: [],
    availableJobLabels: [],
    jobTypesList: null,
    watcher: null,
    isArchive: false,
    isReady: false
  };

  /*
   * Initialize controller and start loading the required data
   * --------------------------------------------------------------------------------
   */
  const loadJobTypes = () => {
    const deferred = $q.defer();
    jobTypesService
      .getAvailable({ isActive: !$scope.Model.isArchive })
      .then(function (jobTypes) {
        $scope.Model.availableJobTypes = jobTypes;
        deferred.resolve(jobTypes);
      });
    return deferred.promise;
  };

  const loadLabels = () => {
    const deferred = $q.defer();
    labelsService
      .getAvailable({
        type: 'job',
        orderBy: 'name',
        coerceTo: 'string',
        isDescending: false,
        isActive: true
      })
      .then((labels) => {
        $scope.Model.availableJobLabels = labels;
        deferred.resolve(labels);
      });
    return deferred.promise;
  };

  const initialize = () => {
    webpage.pageTitle('Loading, please wait');
    loadLabels().then(() => {
      loadJobTypes().then(() => {
        webpage.pageTitle('Tasks : Settings');
        $scope.Model.isReady = true;
      });
    });
  };

  if ($rootScope.CurrentAccount.isAdministrator) {
    initialize();
  }

  /*
   * Events available in Controller Scope
   * --------------------------------------------------------------------------------
   */
  $scope.$on('jobTypeDelete', () => {
    jobTypesService.clearCache();
    actionService.deleteDocuments(
      $scope.Model.jobTypesList.getSelected(),
      jobTypeService.deleteJobType,
      $scope.Model.jobTypesList.removeData,
      'task(s)'
    );
  });
  $scope.$on('jobTypeDuplicate', () => {
    jobTypesService.clearCache();
    actionService.duplicateDocuments(
      $scope.Model.jobTypesList.getSelected(),
      jobTypeService.readJobType,
      jobTypeService.createJobType,
      $scope.Model.jobTypesList.setDataAppend,
      'name',
      ' copy',
      'task(s)'
    );
  });
  $scope.$on('jobTypeActivate', () => {
    jobTypesService.clearCache();
    actionService.toggleDocuments(
      $scope.Model.jobTypesList.getSelected(),
      jobTypeService.updateJobType,
      $scope.Model.jobTypesList.removeData,
      'task(s)',
      true
    );
  });
  $scope.$on('jobTypeArchive', () => {
    jobTypesService.clearCache();
    actionService.toggleDocuments(
      $scope.Model.jobTypesList.getSelected(),
      jobTypeService.updateJobType,
      $scope.Model.jobTypesList.removeData,
      'task(s)',
      false
    );
  });
  $scope.$on('jobTypeAdd', (e, $event) => {
    jobTypesService.clearCache();
    eventService.jobEdit({
      event: $event,
      job: null,
      isJob: false,
      showAccounts: false,
      showTicket: false,
      stage: null,
      jobTypes: [],
      accounts: [],
      workflow: null,
      ticket: null
    });
  });

  /*
   * Methods available in Controller Scope
   * --------------------------------------------------------------------------------
   */
  $scope.jobTypeEdit = ($event, jobType) => {
    eventService.jobEdit({
      event: $event,
      job: jobType,
      isJob: false,
      isStageJob: false,
      showAccounts: false,
      showTicket: false,
      jobTypes: [],
      accounts: [],
      workflow: null,
      ticket: null
    });
  };

  $scope.jobTypeEdited = (jobType) => {
    const jT = jobType;
    jobTypesService.clearCache();
    if (jT.isNew === true) {
      delete jT.isNew;
      if (jT.isActive !== $scope.Model.isArchive) {
        $scope.Model.jobTypesList.setDataAppend(jT);
      }
    } else {
      $scope.Model.jobTypesList.setDataReplace(jT);
    }
  };

  $scope.jobTypeLabelsSelect = ($event, jobType) => {
    eventService.dialogLabelSelect({
      event: $event,
      labels: $scope.Model.availableJobLabels,
      selectedLabels: jobType.idLabels,
      data: jobType
    });
  };

  $scope.jobTypeLabelsSelected = (selectedLabels, jobType) => {
    const jT = jobType;
    jT.idLabels = selectedLabels;
    jobTypesService.clearCache();
    $scope.Model.jobTypesList.setDataReplace(jT);
    jobTypeService.updateJobType(jT);
  };

  $scope.listChange = (list, data, isSelected) => {
    $scope.$parent.Model.childStateHasSelection = isSelected || list.isSelectedAny();
  };

  $scope.listReady = (list) => {
    $scope.Model.jobTypesList = list;
    $scope.Model.watcher = $scope.$parent.$watch(
      'Model.childStateIsArchive',
      (newValue, oldValue) => {
        if (newValue !== oldValue) {
          $scope.Model.isArchive = newValue;
          $scope.Model.isReady = false;
          $scope.Model.watcher();
          loadJobTypes();
        }
      }
    );
  };
};
